import { ArrowLeft, ChevronRight, X } from "lucide-react";
import { Link, useLocation } from "react-router-dom";

import { AnimatedText } from "../ui/animated-text";
import { Button } from "../ui/button";
import { CampaignCountdown } from "../campaign-card/campaign-countdown";
import { campaignRoute } from "@/routes";
import { motion } from "motion/react";
import { useCurrentCampaign } from "@/hooks/use-current-campaign";
import { useHeaderNavigation } from "../../hooks/use-route-title";
import { useSetWidgetOpen } from "../../hooks/widget";

export const WidgetHeader = () => {
  const { closeWidget } = useSetWidgetOpen();
  const { segments, backTo } = useHeaderNavigation();
  const location = useLocation();
  const current = useCurrentCampaign();
  // Timer only makes sense while viewing a campaign.
  const showTimer =
    location.pathname.startsWith(campaignRoute) && current != null;

  return (
    <div className="flex w-full flex-row items-center justify-between p-2 pb-0 lg:p-4">
      {backTo && (
        <Button asChild variant="secondary" size="icon">
          <Link to={backTo}>
            <ArrowLeft className="size-5" />
          </Link>
        </Button>
      )}
      {segments[0] && (
        <motion.div layout className="flex w-full min-w-0 items-center pl-2">
          <span className="inline-flex min-w-0 items-center">
            <AnimatedText text={segments[0]} />
          </span>
          {segments.slice(1).map((segment, i) => (
            <span
              key={`${segment}-${i}`}
              className="hidden min-w-0 items-center lg:inline-flex"
            >
              <ChevronRight className="mx-1 size-4 shrink-0 text-muted-foreground" />
              <AnimatedText text={segment} />
            </span>
          ))}
        </motion.div>
      )}

      <div className="flex flex-row items-center justify-center gap-2 lg:gap-4">
        {showTimer && current && (
          <CampaignCountdown
            campaign={current.campaign}
            variant="header"
            className="shrink-0"
          />
        )}
        <Button size="icon" onClick={closeWidget} variant={"secondary"}>
          <X className="size-5" />
        </Button>
      </div>
    </div>
  );
};
